import { render, staticRenderFns } from "./TargetIcon.vue?vue&type=template&id=35f89985"
import script from "./TargetIcon.vue?vue&type=script&lang=js"
export * from "./TargetIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports